const generateForm02 = [
  {
    label: "ONLINE_LEAVE_SUBMISSION.FORM.DELEGATE_LABEL",
    name: "delegator",
    placeholder: "ONLINE_LEAVE_SUBMISSION.FORM.DELEGATE_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 9, lg: 9 },
    isRequired: true,
    titleRequired: "ONLINE_LEAVE_SUBMISSION.FORM.DELEGATE_REQUIRED",
    disable: false,
    section: "information",
  },
  {
    label: "ONLINE_LEAVE_SUBMISSION.FORM.DELEGATE_PHONE_LABEL",
    name: "delegator_phone",
    placeholder: "ONLINE_LEAVE_SUBMISSION.FORM.DELEGATE_PHONE_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: true,
    titleRequired: "ONLINE_LEAVE_SUBMISSION.FORM.DELEGATE_PHONE_REQUIRED",
    disable: false,
    section: "information",
  },
  {
    label: "ONLINE_LEAVE_SUBMISSION.FORM.CONTACT_DURING_LEAVE_LABEL",
    name: "contact_during_leave",
    placeholder: "ONLINE_LEAVE_SUBMISSION.FORM.CONTACT_DURING_LEAVE_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 9, lg: 9 },
    isRequired: true,
    titleRequired: "ONLINE_LEAVE_SUBMISSION.FORM.CONTACT_DURING_LEAVE_REQUIRED",
    disable: false,
    section: "information",
  },
  {
    label: "ONLINE_LEAVE_SUBMISSION.FORM.PROVINCE_LABEL",
    name: "province",
    placeholder: "ONLINE_LEAVE_SUBMISSION.FORM.PROVINCE_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: true,
    titleRequired: "ONLINE_LEAVE_SUBMISSION.FORM.PROVINCE_REQUIRED",
    disable: false,
    section: "information",
  },
  {
    label: "ONLINE_LEAVE_SUBMISSION.FORM.DISTRICT_LABEL",
    name: "district",
    placeholder: "ONLINE_LEAVE_SUBMISSION.FORM.DISTRICT_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: true,
    titleRequired: "ONLINE_LEAVE_SUBMISSION.FORM.DISTRICT_REQUIRED",
    disable: false,
    section: "information",
  },
  {
    label: "ONLINE_LEAVE_SUBMISSION.FORM.VILLAGE_LABEL",
    name: "district_sub",
    placeholder: "ONLINE_LEAVE_SUBMISSION.FORM.VILLAGE_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: true,
    titleRequired: "ONLINE_LEAVE_SUBMISSION.FORM.VILLAGE_REQUIRED",
    disable: false,
    section: "information",
  },
  {
    label: "ONLINE_LEAVE_SUBMISSION.FORM.ZIP_CODE_LABEL",
    name: "postcode",
    placeholder: "ONLINE_LEAVE_SUBMISSION.FORM.ZIP_CODE_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: true,
    titleRequired: "ONLINE_LEAVE_SUBMISSION.FORM.ZIP_CODE_REQUIRED",
    disable: false,
    section: "information",
  },
  {
    label: "ONLINE_LEAVE_SUBMISSION.FORM.CONTACT_DURING_LEAVE_PHONE_LABEL",
    name: "during_leave_contact",
    placeholder: "ONLINE_LEAVE_SUBMISSION.FORM.CONTACT_DURING_LEAVE_PHONE_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: true,
    titleRequired: "ONLINE_LEAVE_SUBMISSION.FORM.CONTACT_DURING_LEAVE_PHONE_REQUIRED",
    disable: false,
    section: "information",
  },
];

export default generateForm02;
